'use client'

import * as React from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { cn } from '@/true-fsd/shared/utils/css'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root
export type TooltipProps = React.ComponentPropsWithoutRef<typeof Tooltip>

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
    React.ElementRef<typeof TooltipPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
    <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
            ref={ref}
            sideOffset={sideOffset}
            className={cn(
                'border-color-stroke z-50 rounded-[8px] border bg-white p-[4px] text-[10px] shadow-[0px_4px_16px_rgba(21,38,57,0.04)]',
                className
            )}
            side={props.side ?? 'top'}
            {...props}
        >
            {props.children}
            <TooltipPrimitive.Arrow
                className="-my-px border-none fill-white drop-shadow-[0_1px_0_#e9e9ed]"
                width={12}
                height={7}
                aria-hidden="true"
            />
        </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName
export type TooltipContentProps = React.ComponentPropsWithoutRef<
    typeof TooltipContent
>

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
